export const FAVORITE_TYPE = {
    CONTACT: "contacts",
    MASTER_ACCOUNT: "master account",
    ACCOUNT: "accounts",
    CAMPAIGN: "campaigns",
    GROUP: "groups",
    REPORT: "reports",
    SETTING: "settings"
}
